<template>    
    <BaseModal
        :id="'static-uncleaned-rooms'"
        :title="'Uncleaned Rooms'"
        :message="'This is a list of all rooms that need cleaning today, along with the assignments they are included in.'"
        size="lg"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div v-if="loading" class="text-center w-100" style="height: 3rem !important;">
                <div class="spinner-border mt-2" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <FormDynamic v-if="!loading" :form_data="form_data" :form_format="form_format" :array_options="array_options" class="py-0">
                <template v-slot:more-fields>
                    <div class="col-md-8 px-0 pb-0 d-flex align-items-end justify-content-end">
                        <button class="modal__buttons__item w-auto px-3 mt-2 ml-0" style="height: 10px;" v-html="'Print'" @click="getEssentialRoomsNotCleaned(true)" :disabled="loading_printing"/>
                    </div>
                </template>
            </FormDynamic>
            <div class="tab-content mt-4" v-if="uncleaned_rooms.length">
                <div class="tab-pane fade active show" id="listation">
                    <div class="row mb-0 no-gutters">
                        <div class="col-lg-12">
                            <v-card>
                                <DinamicTable
                                    :headers="table_headers"
                                    :items="uncleaned_rooms"
                                    :search="''"
                                    :size="27"
                                />
                            </v-card>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="!uncleaned_rooms.length && !loading" class="alert alert-warning mt-4" role="alert">
                No Records Available
            </div>
            <CentralLiteButtons :done="true"/>
        </template>
    </BaseModal>
</template>

<script>
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import DinamicTable from '@/components/DinamicTable'
import BaseModal from '@/components/BaseModal'
import CentralLiteButtons from '@/components/CentralLiteButtons';
import FormDynamic from '@/components/FormDynamic.vue';

export default {

    name:   'UncleanedRoomsModal',
    props: [
        "rest_api",
        "breadcrumb",
        "array_options"
    ],

    components:{
        CentralLiteButtons,
        Breadcrumb,
        BaseModal,
        FormDynamic,
        DinamicTable
    },

    data(){
        return {
            uncleaned_rooms: [],
            loading: true,
            loading_printing: false,
            table_headers: [
                {
                    text:   "Room",
                    value:  "room",
                    report_value: 'room',
                    show: true,
                    style: 'width: 40%'
                },
                {
                    text:   "Task",
                    value:  "task",
                    report_value: 'task',
                    show: true,
                    style: 'width: 10%'
                },
                {
                    text:   "Daily Assignment",
                    value:  "daily_assignment",
                    report_value: 'daily_assignment',
                    show: true,
                    style: 'width: 40%'
                },
                {
                    text:   "Essential Cleaning",
                    value:  "essential_cleaning",
                    report_value: 'essential_cleaning',
                    show: true,
                    style: 'width: 10%'
                },
            ],
            form_data: {
                essential_cleaning: '',
                print: false
            },
            form_format: [{
                css_class:  'col-md-4 col-sm-12 pr-3 pl-0',
                type:       'select',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Essential Cleaning:',
                model_name: 'essential_cleaning',
                ref:        'essential_cleaning_input',
                ref_alt:    'essential_cleaning_input_alt',
                required:   false,
            }]
        }
    },

    watch: {
        async 'form_data.essential_cleaning' ()
        {
            this.getEssentialRoomsNotCleaned()
        }
    },

    methods:{
        async getEssentialRoomsNotCleaned(print = false)
        {
            if(print)
            {
                this.form_data.print = true
                this.loading_printing = true
            }
            else
            {
                this.uncleaned_rooms = []
                this.form_data.print = false
                this.loading = true
            }

            const response = await this.post(`${this.rest_api}/uncleaned_rooms`, {...this.form_data, table_headers: this.table_headers})
            this.loading = false
            this.loading_printing = false

            if(response.status)
            {
                if(print)
                {
                    this.downloadFile(response)
                }
                else
                {
                    this.uncleaned_rooms = response.data.data
                }
            }
            else
            {
                this.error_handling(response)
            }

        },
    },

    mounted(){

    }
    
}
</script>